import { createContext } from "react";

// Missing account-scoped context never grants generation.
export const CaiGenerationEntitlementContext = createContext(false);
export const CaiGenerationEntitlementBoundary = CaiGenerationEntitlementContext.Provider;
